import { render, staticRenderFns } from "./SimpleCardSummary.vue?vue&type=template&id=157c7700&"
import script from "./SimpleCardSummary.vue?vue&type=script&lang=ts&"
export * from "./SimpleCardSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports